import {HTTPClient} from './http.service';

export const bookingManagementService = {
  async addBooking(data) {
    try {
      const result = await HTTPClient.post('/mallVisit/', data);
      return result;
    } catch(error) {
      let error_object;
      if (error.status === 422 && error.data.status.code === 422) error_object = error.data.status.message;
      else if (error.status === 400 && error.data.status.code === 400) error_object = error.data.status.message;
      else error_object = 'UNKNOWN ERROR'
      throw error_object;
    }
  },
  async getBookingManagementById (id) {
    try {
      let result = await HTTPClient.get('mallVisit/settings')
      return result;
    } catch (error) {
      return error;
    }
  },
  async getBookingManagementList (data){
    try {
      let result = await HTTPClient.get('/mallVisit/', data)
      return result;
    } catch (error) {
      return error;
    }
  },
  async getBookingManagementUsersList (data){
    try {
      let result = await HTTPClient.get('/mallVisit/booking/', data)
      return result;
    } catch (error) {
      return error;
    }
  },
  async updateBooking (data, id) {
    try {
      let result = await HTTPClient.put(`/mallVisit/${id}`, data)
      return result;
    } catch (error) {
      return error;
    }
  },
  async cancelBooking (data, date) {
    try {
      let result = await HTTPClient.deleteWithBody(`/mallVisit/${date}`, data)
      return result;
    } catch (error) {
      let error_object;
      if (error.status === 422 && error.data.status.code === 422) error_object = error.data.status.message;
      else if (error.status === 400 && error.data.status.code === 400) error_object = error.data.status.message;
      else error_object = 'UNKNOWN ERROR'
      throw error_object;
    }
  }
}